<!-- TEMPLATE CONTRACT: Ui Datepicker Component owns the visible Angular template structure for src/app/shared/ui/ui-datepicker/ui-datepicker.component.html. -->
<div class="ui-datepicker">
  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (label()) {
    <label class="ui-datepicker__label" [attr.for]="id() || null">
      {{ label() | uiLabelTranslate }}
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (required()) {
        <span class="ui-datepicker__required">*</span>
      }
    </label>
  }

  <p-datepicker
    class="ui-datepicker__control"
    [inputId]="id() || undefined"
    [ngModel]="dateValue()"
    (ngModelChange)="onDateChange($event)"
    [placeholder]="placeholder() | uiLabelTranslate"
    [disabled]="disabled()"
    [showIcon]="showIcon()"
    [dateFormat]="dateFormat()"
    [showButtonBar]="true"
    appendTo="body"
    styleClass="ui-datepicker__prime"
  />

  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (error()) {
    <p class="ui-datepicker__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-datepicker__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
